<template>
  <div id="wecomcustomer">
    <div class="header flex-between">
      <div class="header-text">
        <h1>企微管理\客户迁移</h1>
      </div>
      <div class="header-button" style="display: flex; align-items: center">
        <el-button
            icon="el-icon-search"
            @click="SearchBtn"
            v-if="jurisdiction.search"
        >查询</el-button
        >
        <el-button
            v-if="jurisdiction.search"
            icon="el-icon-notebook-2"
            @click="conditionDialog = true"
        >展开隐藏条件</el-button
        >
        <el-button
            v-if="jurisdiction.search"
            icon="el-icon-delete"
            @click="eliminate"
        >清除查询条件</el-button
        >
        <el-button
            v-if="jurisdiction.daochu"
            icon="el-icon-folder-opened"
            @click="exportShow = true"
        >导出</el-button
        >
        <el-button
            v-if="jurisdiction.daochu"
            icon="el-icon-download"
            @click="(downloadShow = true), getDownladExportList()"
        >下载导出结果</el-button
        >
        <el-button
            icon="el-icon-edit-outline"
            @click="ImprotExcel"
            v-if="jurisdiction.Import"
        >导入</el-button
        >
        <el-button
            v-if="jurisdiction.Import"
            icon="el-icon-download"
            @click="(downloadShow = true), getDownladList()"
        >下载导入结果</el-button
        >
      </div>
    </div>
    <!-- 查询框 -->
    <el-card shadow="never">
      <div class="searchform">
        <el-form
            :label-position="labelPosition"
            label-width="100px"
            :model="queryInfo"
            size="mini"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="门店">
                <el-select
                    style="width: 100%"
                    multiple
                    v-model="queryInfo.deptIdArr"
                >
                  <el-option
                      v-for="item in orgIDList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item  label="添加人账号">
                <el-input   placeholder="请输入内容" v-model="queryInfo.wecharUserID" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item  label="绑定手机号">
                <el-input   placeholder="请输入内容" v-model="queryInfo.mobile" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item  label="客户企微昵称">
                <el-input   placeholder="请输入内容" v-model="queryInfo.custName" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never" class="centercard">
      <el-table
          :key="key"
          size="small"
          class="table-style"
          :height="isMore ? 'calc(100vh - 22.5rem)' : 'calc(100vh - 20rem)'"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            color: '#6C6839',
            'text-align': 'center',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          v-el-table-infinite-scroll="load"
          v-loading="loading"
          infinite-scroll-disabled="onLoading"
      >
        <!--        <el-table-column type="selection" width="55"/>-->
        <el-table-column type="index" label="No."></el-table-column>
        <el-table-column prop="weChatOpenID" label="客户UNIONID" min-width="180"> </el-table-column>
        <el-table-column prop="cardNo" label="CRM会员卡号" min-width="140"> </el-table-column>
        <el-table-column prop="userName" label="客户昵称" min-width="100"> </el-table-column>
        <el-table-column prop="remark" label="客户备注" min-width="100"> </el-table-column>
        <el-table-column prop="createtimeStr" label="添加时间" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.createtimeStr | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="addWay" label="来源"></el-table-column>
        <el-table-column prop="name" label="添加人姓名" min-width="100"> </el-table-column>
        <el-table-column prop="alias" label="添加人别名" min-width="100"> </el-table-column>
        <el-table-column prop="mobile" label="绑定手机号" min-width="100"> </el-table-column>
        <el-table-column prop="wecharUserID" label="添加人账号" min-width="100"> </el-table-column>
        <el-table-column prop="regionName" label="区域"> </el-table-column>
        <el-table-column prop="deptName" label="门店名"></el-table-column>
        <el-table-column prop="deptCode" label="门店编号"></el-table-column>
        <el-table-column prop="position" label="职务" min-width="100"></el-table-column>
        <el-table-column prop="tag1" label="标签组1(客户类型)" min-width="200"> </el-table-column>
        <el-table-column prop="tag2" label="标签组2(会员等级(动态标签))" min-width="220"> </el-table-column>
        <el-table-column prop="tag3" label="标签组3(会员折扣偏好(动态标签))" min-width="240"> </el-table-column>
        <el-table-column prop="tag4" label="标签组4(客户活跃度(动态标签))" min-width="220"> </el-table-column>
        <el-table-column prop="tag5" label="标签组5(会员注册时间(动态标签))" min-width="240"> </el-table-column>
        <el-table-column prop="tag6" label="标签组6(纪念日(动态标签))" min-width="200"> </el-table-column>
        <el-table-column prop="tag7" label="标签组7(来源渠道)" min-width="200"> </el-table-column>
      </el-table>

      <el-alert
          v-if="isMore"
          title="没有更多啦!"
          type="warning"
          center
          :closable="false"
      ></el-alert>
    </el-card>


    <div class="exporttc">
      <el-dialog
          :close-on-click-modal="false"
          width="20%"
          title="导出客户迁移记录"
          :visible.sync="exportShow"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
                class="iconfont icon-jingshi"
                style="font-size: 28px; color: #f39b21"
            ></i>
            是否确定<span style="color: #ff0000">导出</span>客户迁移记录?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="exportCustomer">确 定</el-button>
          <el-button @click="exportShow = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 导入保存确认对话框 -->
    <div class="import">
      <el-dialog
          title="企微管理\客户迁移导入"
          :visible.sync="WeComCustmerImport"
          :close-on-click-modal="false"
          width="40%"
      >
        <el-form
            size="mini"
            label-width="225px"
            ref="newUploadForm"
            enctype="multipart/form-data"
        >
          <el-form-item label="选择待导入文件" :required="true">
            <div class="flex-start">
              <el-input
                  style="width: 300px"
                  v-model="filename"
                  :readonly="true"
                  placeholder="请选择文件名"
              >
              </el-input>
              <el-upload
                  class="upload"
                  action="#"
                  :show-file-list="false"
                  :on-change="onFileChange"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  :auto-upload="false"
              >
                <el-button style="margin-left: 20px">选择文件</el-button>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="文案" :required="true">
            <el-input
                v-model="importmsg"
                autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button icon="el-icon-download" @click="templatebtn"
          >下载模板</el-button
          >
           <el-button  @click="Selectupload"
           >提交</el-button
           >
        </span>

      </el-dialog>


    </div>
    <!-- 筛选条件弹窗 -->
    <el-dialog
        append-to-body
        width="1200px"
        :visible.sync="conditionDialog"
        :close-on-click-modal="false"
    >
      <el-row>
        <el-col :span="24">
          <el-form
              :model="queryInfo"
              size="small"
              :inline="true"
              label-width="200px"
          >
            <el-form-item label="门店">
              <el-select
                  style="width: 100%"
                  multiple
                  v-model="queryInfo.deptIdArr"
              >
                <el-option
                    v-for="item in orgIDList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item  label="添加人账号">
              <el-input   placeholder="请输入内容" v-model="queryInfo.wecharUserID" clearable></el-input>
            </el-form-item>

            <el-form-item  label="绑定手机号">
              <el-input   placeholder="请输入内容" v-model="queryInfo.mobile" clearable></el-input>
            </el-form-item>

            <el-form-item  label="客户企微昵称">
              <el-input   placeholder="请输入内容" v-model="queryInfo.custName" clearable></el-input>
            </el-form-item>
<!--            <el-form-item  label="添加人姓名">-->
<!--              <el-input   placeholder="请输入内容" v-model="queryInfo.userName" clearable></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="区域">
              <el-select
                  style="width: 100%"
                  multiple
                  v-model="queryInfo.regionIdArr"
              >
                <el-option
                    v-for="item in regionIDList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item  label="客户备注">
              <el-input   placeholder="请输入内容" v-model="queryInfo.remark" clearable></el-input>
            </el-form-item>
            <el-form-item label="标签组">
              <el-col :span="16">
                <textarea rows="8" v-model="ServiceTagName" ></textarea>
              </el-col>
              <el-col :span="8">
                <el-button
                    style="margin-left: 10px"
                    @click="
                    (outletVisible = true),
                      (flag = 1),
                      (tagId = queryInfo.tagIDArr)
                  "
                >选择标签</el-button
                >
              </el-col>
            </el-form-item>

            <el-form-item label="添加人姓名">
              <el-col :span="16">
                <div class="boxstr" @click="pitchup($event)">
                  <li
                      v-for="(item, index) in queryInfo.emplist"
                      :key="index"
                      :data-name="item.empName"
                      :class="{
                        changeStyle: rSelect.indexOf(item.empName) != -1,
                      }"
                  >
                    {{ item.empName }}
                  </li>
                </div>
              </el-col>
              <el-col :span="8">
                <el-button
                    style="margin-left: 10px"
                    @click="addbtn"
                >增加添加人</el-button>
                <el-button
                    style="margin-left: 10px"
                    @click="deletebtn"
                >删除添加人</el-button
                >
              </el-col>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <hr style="border: 0; border-top: 1px dashed #C7A673; margin: 10px 0;">
      <el-row>
        <el-col :span="12">
          <el-form
              :model="queryInfo"
              size="small"
              :inline="true"
              label-width="130px"
          >
            <el-form-item label="卡号">
              <el-input v-model="queryInfo.cardNo"></el-input>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="queryInfo.userName"></el-input>
            </el-form-item>
            <el-form-item label="电话号码">
              <el-input v-model="queryInfo.Mobile"></el-input>
            </el-form-item>
            <el-form-item label="维护区域">
              <el-select
                  v-model="queryInfo.regionIds"
                  multiple
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in Regioncax"
                    :key="item.id"
                    :label="item.lable"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="维护店1">
              <el-col :span="16">
                <textarea rows="8" v-model="ServiceOrgName" readonly></textarea>
              </el-col>
              <el-col :span="8">
                <el-button
                    style="margin-left: 10px"
                    @click="
                    (outOrgletVisible = true),
                      (flag = 3),
                      (shopId = queryInfo.shopIds)
                  "
                >选择门店</el-button
                >
              </el-col>
            </el-form-item>
            <el-form-item label="维护人">
              <el-input v-model="queryInfo.ServiceEmpName"></el-input>
            </el-form-item>
            <el-form-item label="注册日期">
              <el-date-picker
                  v-model="dateValue1"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="省份">
              <el-input v-model="queryInfo.provinceName"></el-input>
            </el-form-item>
            <el-form-item label="城市">
              <el-input v-model="queryInfo.cityName"></el-input>
            </el-form-item>
            <el-form-item label="会员等级">
              <el-select
                  style="width: 100%"
                  multiple
                  v-model="queryInfo.LevelID"
              >
                <el-option
                    v-for="item in checkbooksData"
                    :key="item.levelID"
                    :value="item.levelID"
                    :label="item.levelName_cn"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生日所在月份">
              <div class="flex-between">
                <el-select
                    style="width: 45%"
                    v-model="queryInfo.birthMonthStart"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item in months"
                      :key="item"
                      :label="item + '月'"
                      :value="item"
                  >
                  </el-option>
                </el-select>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-select
                    style="width: 45%"
                    v-model="queryInfo.birthMonthEnd"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item in months"
                      :key="item"
                      :label="item + '月'"
                      :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="生日所在日期">
              <div class="flex-between">
                <el-select
                    style="width: 45%"
                    v-model="queryInfo.birthDateStart"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item in days"
                      :key="item"
                      :label="item + '日'"
                      :value="item"
                  >
                  </el-option>
                </el-select>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-select
                    style="width: 45%"
                    v-model="queryInfo.birthDateEnd"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item in days"
                      :key="item"
                      :label="item + '日'"
                      :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="年龄">
              <div class="flex-between">
                <el-input v-model="queryInfo.ageMin"></el-input>
                <span style="margin: 0 1rem 0 1rem">到</span>
                <el-input v-model="queryInfo.ageMax"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="最近购买日">
              <el-date-picker
                  v-model="dateValue3"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="会员TAG">
              <el-select
                  v-model="queryInfo.tagIds"
                  multiple
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in memberTagList"
                    :key="item.userDefineID"
                    :label="item.description_CN"
                    :value="item.userDefineID"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否商城VIP">
              <el-select v-model="queryInfo.isMillVIP" placeholder="请选择">
                <el-option value="" label="所有"></el-option>
                <el-option value="1" label="是"></el-option>
                <el-option value="0" label="否"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="非分配维护人">
              <el-select v-model="queryInfo.isServiceEmp" placeholder="请选择">
                <el-option value="" label="所有"></el-option>

                <el-option value="1" label="已分配"></el-option>

                <el-option value="0" label="未分配"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="今年消费额">
              <div class="flex-between">
                <el-input
                    v-model="queryInfo.CurrYearAmountMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="queryInfo.CurrYearAmountMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="去年消费额">
              <div class="flex-between">
                <el-input
                    v-model="queryInfo.PrevYearAmountMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="queryInfo.PrevYearAmountMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="最近一年消费额">
              <div class="flex-between">
                <el-input
                    v-model="queryInfo.LastYearAmountMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="queryInfo.LastYearAmountMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
        </el-col>

        <el-col :span="12">
          <el-form
              :model="queryInfo"
              size="small"
              :inline="true"
              label-width="130px"
          >
            <el-form-item label="TOP1客单价">
              <div class="flex-between">
                <el-input
                    v-model="queryInfo.SheetTopAmt1Min"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="queryInfo.SheetTopAmt1Max"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="TOP2客单价">
              <div class="flex-between">
                <el-input
                    v-model="queryInfo.SheetTopAmt2Min"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="queryInfo.SheetTopAmt2Max"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="TOP3客单价">
              <div class="flex-between">
                <el-input
                    v-model="queryInfo.SheetTopAmt3Min"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="queryInfo.SheetTopAmt3Max"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="M期间消费金额">
              <div class="flex-between">
                <el-input
                    v-model="queryInfo.MonetaryMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="queryInfo.MonetaryMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="F期间消费次数">
              <div class="flex-between">
                <el-input
                    v-model="queryInfo.FrequencyMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="queryInfo.FrequencyMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="T期间的最大单">
              <div class="flex-between">
                <el-input
                    v-model="queryInfo.TMaxMoneyMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="queryInfo.TMaxMoneyMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="RMF标签">
              <div class="flex-between">
                <el-select
                    style="width: 100%"
                    multiple
                    v-model="queryInfo.saleTagID"
                >
                  <el-option
                      v-for="item in levelRmfList"
                      :key="item.sortIndex"
                      :value="item.sortIndex"
                      :label="item.description_CN"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="当前是否保级">
              <div class="flex-between">
                <el-select
                    v-model="queryInfo.HasRelegation"
                    placeholder="请选择"
                >
                  <el-option value="" label="所有"></el-option>
                  <el-option value="1" label="是"></el-option>

                  <el-option value="0" label="否"> </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="保级日期">
              <el-date-picker
                  v-model="protectionDate"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="当前可能降级级别">
              <div class="flex-between">
                <el-select
                    style="width: 100%"
                    multiple
                    v-model="queryInfo.CanDegradeLvl"
                >
                  <el-option
                      v-for="item in checkbooksData"
                      :key="item.levelID"
                      :value="item.levelID"
                      :label="item.levelName_cn"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="当前可用积分">
              <div class="flex-between">
                <el-input
                    v-model="queryInfo.CurrAvailPointMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="queryInfo.CurrAvailPointMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="去年累计积分">
              <div class="flex-between">
                <el-input
                    v-model="queryInfo.PreYearPointsMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="queryInfo.PreYearPointsMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="今年累计积分">
              <div class="flex-between">
                <el-input
                    v-model="queryInfo.CurrYearPointsMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="queryInfo.CurrYearPointsMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="升级为VIC的时间">
              <el-date-picker
                  v-model="dateValue4"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="升级为VIC的机构">
              <el-col :span="16">
                <textarea
                    rows="8"
                    v-model="FirstVipOrgName"
                    readonly
                ></textarea>
              </el-col>
              <el-col :span="8">
                <el-button
                    style="margin-left: 10px"
                    @click="
                    (outOrgletVisible = true),
                      (flag = 4),
                      (shopId = queryInfo.UpdateLvlOrgIds)
                  "
                >选择门店</el-button
                >
              </el-col>
            </el-form-item>
            <el-form-item label="升级为VIC的区域">
              <el-select
                  v-model="queryInfo.UpdateLvlRegionIds"
                  multiple
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in Regioncax"
                    :key="item.id"
                    :label="item.lable"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="去年消费次数">
              <div class="flex-between">
                <el-input
                    v-model="queryInfo.PrevYearSaleTimesMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="queryInfo.PrevYearSaleTimesMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="今年消费次数">
              <div class="flex-between">
                <el-input
                    v-model="queryInfo.CurrYearSaleTimesMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="queryInfo.CurrYearSaleTimesMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="平均客单价">
              <div class="flex-between">
                <el-input
                    v-model="queryInfo.AvgSheetAmtMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="queryInfo.AvgSheetAmtMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="平均折扣">
              <div class="flex-between">
                <el-input
                    v-model="queryInfo.AvgDiscountMin"
                    style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                    v-model="queryInfo.AvgDiscountMax"
                    style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <div slot="title">
        <div class="dialogTitle">
          <span>条件</span>
          <div></div>
          <div>
            <el-button @click="SearchBtn(), (conditionDialog = false)"
            >查 询</el-button
            >
            <el-button @click="eliminate(), (conditionDialog = false)"
            >清除查询条件</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 下载弹窗 -->
    <el-dialog
        append-to-body
        width="50%"
        :visible.sync="downloadShow"
        title="下载导入结果"
    >
      <el-table
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="downloadData"
          tooltip-effect="dark"
          style="width: 100%"
      >
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column
            prop="startTime"
            label="导入开始时间"
        ></el-table-column>

        <el-table-column prop="endTime" label="导入结束时间"></el-table-column>

        <el-table-column prop="isComplate" label="状态">
          <template slot-scope="scope">
            {{ scope.row.isComplate ? "完成" : "执行中" }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="下载">
          <template slot-scope="scope">
            <el-button
                icon="el-icon-download"
                v-if="scope.row.isComplate"
                @click="download(scope.row.downloadUrl)"
            >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadShow = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 选择门店 -->
    <div class="outlet">
      <el-dialog
          :close-on-click-modal="false"
          width="35%"
          :visible.sync="outOrgletVisible"
          title="选择门店"
          class="store-modal"
      >
        <el-form size="mini" label-width="90px">
          <el-row v-for="(item, index) in StoreSelectionList" :key="index">
            <el-col :span="12" v-for="(myitem, myindex) in item" :key="myindex">
              <el-tree
                  ref="tree"
                  v-if="myitem != undefined"
                  :data="[myitem]"
                  show-checkbox
                  node-key="shopID"
                  highlight-current
                  default-expand-all
                  :default-checked-keys="shopId"
                  :props="defaultProps"
              >
              </el-tree>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ComButtomStore">确 定</el-button>
          <el-button @click="outOrgletVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 标签弹窗 -->
    <el-dialog
        append-to-body
        width="35%"
        :visible.sync="outletVisible"
        title="选择标签"
        class="store-modal"
    >
      <el-form size="mini" label-width="90px">
        <el-row v-for="(item, index) in TagSelectionList" :key="index">
          <el-col :span="12" v-for="(myitem, myindex) in item" :key="myindex">
            <el-tree
                ref="tree"
                v-if="myitem != undefined"
                :data="[myitem]"
                show-checkbox
                node-key="ShopID"
                highlight-current
                default-expand-all
                :default-checked-keys="tagId"
                :props="defaultTagProps"
            >
            </el-tree>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ComButtomTag">确 定</el-button>
        <el-button @click="outletVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <div class="fittin">
      <el-dialog
          width="80%"
          title="企微管理\客户迁移—选择添加人姓名"
          :visible.sync="experimental"
          :close-on-click-modal="false"
      >
        <el-form :inline="true" :model="PagesStaff" class="demo-form-inline">
          <el-form-item label="姓名">
            <el-input v-model="PagesStaff.empName" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="用户编号">
            <el-input v-model="PagesStaff.empCode" placeholder=""></el-input>
          </el-form-item>
          <el-form-item>
            <el-button icon="iconfont icon-sousuo1" @click="searchhy"
            >查询</el-button
            >
          </el-form-item>
        </el-form>

        <el-table
            height="300"
            ref="MagerTableStaff"
            class="table-style"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
                background: '#FCFBF2',
                color: '#6C6839',
                'text-align': 'center',
              }"
            :cell-style="{ 'text-align': 'center' }"
            :data="skuship"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChangeStaff"
            v-el-table-infinite-scroll="PageTouchTheBottomStaff"
            infinite-scroll-disabled="infiniteScrollDisabledIsStaff"
            v-loading="PageTableLoadingStaff"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column type="index" label="No."></el-table-column>
          <el-table-column prop="empName" label="姓名"> </el-table-column>
          <el-table-column
              prop="empCode"
              label="用户编号"
          ></el-table-column>
          <el-table-column prop="empKindText" label="员工类型">
          </el-table-column>
        </el-table>
        <el-alert
            v-if="PagesIsMoreStaff"
            title="没有更多数据了!"
            type="warning"
            center
            :closable="false"
        >
        </el-alert>
        <div slot="footer" class="dialog-footer">
          <el-button @click="affirm">确 定</el-button>
          <el-button @click="experimental = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {RegionApi, reportFormList} from "@/api/reportForm";
import {followUserExportApi, importWebComExlsx, queryFollowUserRequestLisApi, queryTagListApi,regionalQuery} from "@/api/wecom";
import {selectEmpList} from "@/api/viewMemberModule";
import {getcpyNo} from "@/utils/auth";
import {queryLSelectApi, queryRmfSelectApi} from "@/api/user";
import {definedQueryListApi} from "@/api/region";
export default {
  name: "Wecomcustomer",
  data() {
    return {
      downloadData: [],
      downloadShow: false,
      loadingg: false,
      exportShow: false,
      filename: "",
      custID: [],
      radio1: "",
      //展开文字
      text: "点击展开",
      showSearch: false,
      showAll: true, //是否展开全部
      applyVisible: false,
      // isMore: false,
      loading: false,
      PageTableLoadingStaff: false,
      deleteFormVisible: false,
      WeComCustmerImport: false,
      conditionDialog: false,
      // defaultisderived: false,
      labelPosition: "right",
      //所属门店数据
      Storsed: [], //转之前
      Storsedes: [],
      importmsg: "",
      file: null,
      handleSelectionValue: [], // 选中值
      followUserIDValue: [], // 选中值
      size: 0,
      fileName: null,
      currentPage: 1, //默认开始页面
      pagesize: 0, //每页的数据条数
      tableData: [], //列表数据
      dateValue1: [], //注册日期
      dateValue3: [], //最近购买日
      dateValue4: [], //创建日期
      protectionDate: [], //保级日期
      // 请求参数
      queryInfo: {
        pageNo: 1,
        pageSize: 100,
        search: "", //搜索
        pages: 0,
        deptName: "", //部门名称
        wecharUserID: "", //添加人账户
        mobile: "", //手机号
        custName: "", //客户姓名
        userName: "", //添加人姓名
        regionName: "", //区域
        deptIdArr: [], //区域列表
        regionIdArr: [], //门店列表
        remark: "", //客户备注
        tagIDArr: [], // 标签
        wecharUserIDArr: [], // 添加人ID
        emplist: [], // 添加人
        multipleQty: false,
        RegistDateStart: "", // 注册开始时间
        RegistDateEnd: "", // 注册结束时间
        CreateTimeStart: "", // 创建时间开始
        CreateTimeEnd: "", // 创建时间结束
        regionIds: [], // 维护区域
        LevelID: [], // 等级
        cardNo: "", // 卡号
        userName1: "", // 姓名
        Mobile: "", // 电话号码
        shopIds: [], // 维护店
        serviceShopIds: [], // 维护店1
        provinceName: "", // 省
        ServiceEmpName: "", // 维护人
        cityName: "", // 市
        birthMonthStart: "",
        birthMonthEnd: "",
        birthDateStart: "",
        birthDateEnd: "",
        ageMin: "",
        ageMax: "",
        LastSaleDateStart: "", // 最近购买日
        LastSaleDateEnd: "", // 最近购买日
        tagIds: [], // 会员TAG
        isMillVIP: "", // 是否商城VIP
        isServiceEmp: "", // 非分配维护人
        CurrYearAmountMin: "", // 今年消费额
        CurrYearAmountMax: "", // 今年消费额
        PrevYearAmountMin: "", // 去年消费额
        PrevYearAmountMax: "", // 去年消费额
        LastYearAmountMin: "", // 最近一年消费额
        LastYearAmountMax: "", // 最近一年消费额
        SheetTopAmt1Min: "", // TOP1客单价
        SheetTopAmt1Max: "", // TOP1客单价
        SheetTopAmt2Min: "", // TOP2客单价
        SheetTopAmt2Max: "", // TOP2客单价
        SheetTopAmt3Min: "", // TOP3客单价
        SheetTopAmt3Max: "", // TOP3客单价
        MonetaryMin: "", // M期间消费金额
        MonetaryMax: "", // M期间消费金额
        FrequencyMin: "", // F期间消费次数
        FrequencyMax: "", // F期间消费次数
        TMaxMoneyMin: "", // T期间最大单
        TMaxMoneyMax: "", // T期间最大单
        saleTagID: "", //RMF标签
        HasRelegation: "", // 当前是否已保级
        CanDegradeLvl: "", // 当前可能降级级别
        CurrAvailPointMin: "", // 当前可用积分
        CurrAvailPointMax: "", // 当前可用积分
        PreYearPointsMin: "", // 去年累计积分
        PreYearPointsMax: "", // 去年累计积分
        CurrYearPointsMin: "", // 今年累计积分
        CurrYearPointsMax: "", // 今年累计积分
        FirstVipDateStart: "", // 升级为VIC的时间
        FirstVipDateEnd: "", // 升级为VIC的时间
        lvlExpireDateStart: "",
        lvlExpireDateEnd: "",
        UpdateLvlOrgIds: [], // 升级为VIC的机构
        UpdateLvlRegionIds: [], // 升级为VIC的区域
        PrevYearSaleTimesMin: "", // 去年消费次数
        PrevYearSaleTimesMax: "", // 去年消费次数
        CurrYearSaleTimesMin: "", // 今年消费次数
        CurrYearSaleTimesMax: "", // 今年消费次数
        AvgSheetAmtMin: "", // 平均客单价
        AvgSheetAmtMax: "", // 平均客单价
        AvgDiscountMin: "", // 平均折扣
        AvgDiscountMax: "", // 平均折扣
      },
      regionIDList: [], //区域列表
      orgIDList: [], //门店列表
      //下载成功之后赋值数据
      successUrl: {},
      count: 1,
      jurisdiction: {
        search: false,
        apply: false,
        Import: false,
      },
      queryinfoqqq: {
        pageNo: 1,
        pageSize: 100,
        pages: 0,
      },

      Regioncax: [], //区域
      outletVisible: false, //标签弹窗
      outOrgletVisible: false, //门店弹窗
      TagSelectionList: [], //选择标签数据
      TagSelectLength: 0,
      TagdataArray: [],
      ServiceTagName: "",
      defaultTagProps: {
        children: "chlidren",
        label: "groupName",
      },
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
      tagId: [],
      key: "",
      SelectStyle: "",
      rSelect: [],
      experimental: false,
      endRow: "", //表格已返回条数
      total: "", //表格总条数
      skuship: [], //存储列表
      lingsList: [],
      PagesStaff: {
        //选择人员列表参数
        pageNo: 1,
        pageSize: 50,
        pagesTotal: 0,
        total: 0,
        empCode: "",
        empName: "",
      },
      checkbooksData: [], //会员等级
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      // 选择门店数据
      shopId: [],
      StoreSelectionList: [],
      StoredataArray: [],
      StoreSelectLength: 0,
      flag: 0,

      memberTagList: [],
      ServiceOrgName: "", //维护店
      FirstVipOrgName: "", //升级为VIC的机构
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      days: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      levelRmfList: [],
      spanArr: [],
      spanArrTow: [],
    };
  },
  created() {
    queryRmfSelectApi({ defineKindID: -1 }).then(
        (res) => (this.levelRmfList = res.data)
    );
    let arrDkDs = [13];
    definedQueryListApi({ defineKindIDs: arrDkDs.join(",") }).then((res) => {
      this.memberTagList = res.data["13"] || []; // 会员TAG
    });
    queryLSelectApi({ cpyNO: getcpyNo() }).then((res) => {
      this.checkbooksData = res.data;
    });
    let WeComCustomer = JSON.parse(localStorage.getItem("WeComCustomer"));
    for (let i = 0; i < WeComCustomer.length; i++) {
      if (WeComCustomer[i].menuName === "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (WeComCustomer[i].menuName === "导入") {
        this.jurisdiction.Import = true;
        continue;
      }
      if (WeComCustomer[i].menuName === "导出") {
        this.jurisdiction.daochu = true;
        continue;
      }
    }
    this.viewCustomers();
    this.QueryTagList();
    this.regioNalinformation();
    this.orgInformation();
    this.ShopqueryRegionList();
  },
  computed: {
    isMoress() {
      //当起始页数等于总页数时停止加载
      return this.queryinfoqqq.pageNo >= this.queryinfoqqq.pages;
    },
    onloadingg() {
      return this.loadingg || this.isMoress;
    },
    isMore() {
      return this.queryInfo.pageNo >= this.queryInfo.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    PagesIsMoreStaff() {
      return this.PagesStaff.pageNo >= this.PagesStaff.pagesTotal;
    },
    infiniteScrollDisabledIsStaff() {
      return this.PageTableLoadingStaff || this.PagesIsMoreStaff;
    },
  },
  methods: {
    eliminate() {
      this.queryInfo = {
        pageNo: 1,
        pageSize: 100,
        search: "", //搜索
        pages: 0,
        deptName: "", //部门名称
        wecharUserID: "", //添加人账户
        mobile: "", //手机号
        custName: "", //客户姓名
        userName: "", //添加人姓名
        regionName: "", //区域
        deptIdArr: [], //区域列表
        regionIdArr: [], //门店列表
        remark: "", //客户备注
        tagIDArr: [], // 标签
        wecharUserIDArr: [], // 添加人ID
        emplist: [], // 添加人
        multipleQty: false,
        RegistDateStart: "", // 注册开始时间
        RegistDateEnd: "", // 注册结束时间
        CreateTimeStart: "", // 创建时间开始
        CreateTimeEnd: "", // 创建时间结束
        regionIds: [], // 维护区域
        LevelID: [], // 等级
        cardNo: "", // 卡号
        userName1: "", // 姓名
        Mobile: "", // 电话号码
        shopIds: [], // 维护店
        serviceShopIds: [], // 维护店1
        provinceName: "", // 省
        ServiceEmpName: "", // 维护人
        cityName: "", // 市
        birthMonthStart: "",
        birthMonthEnd: "",
        birthDateStart: "",
        birthDateEnd: "",
        ageMin: "",
        ageMax: "",
        LastSaleDateStart: "", // 最近购买日
        LastSaleDateEnd: "", // 最近购买日
        tagIds: [], // 会员TAG
        isMillVIP: "", // 是否商城VIP
        isServiceEmp: "", // 非分配维护人
        CurrYearAmountMin: "", // 今年消费额
        CurrYearAmountMax: "", // 今年消费额
        PrevYearAmountMin: "", // 去年消费额
        PrevYearAmountMax: "", // 去年消费额
        LastYearAmountMin: "", // 最近一年消费额
        LastYearAmountMax: "", // 最近一年消费额
        SheetTopAmt1Min: "", // TOP1客单价
        SheetTopAmt1Max: "", // TOP1客单价
        SheetTopAmt2Min: "", // TOP2客单价
        SheetTopAmt2Max: "", // TOP2客单价
        SheetTopAmt3Min: "", // TOP3客单价
        SheetTopAmt3Max: "", // TOP3客单价
        MonetaryMin: "", // M期间消费金额
        MonetaryMax: "", // M期间消费金额
        FrequencyMin: "", // F期间消费次数
        FrequencyMax: "", // F期间消费次数
        TMaxMoneyMin: "", // T期间最大单
        TMaxMoneyMax: "", // T期间最大单
        saleTagID: "", //RMF标签
        HasRelegation: "", // 当前是否已保级
        CanDegradeLvl: "", // 当前可能降级级别
        CurrAvailPointMin: "", // 当前可用积分
        CurrAvailPointMax: "", // 当前可用积分
        PreYearPointsMin: "", // 去年累计积分
        PreYearPointsMax: "", // 去年累计积分
        CurrYearPointsMin: "", // 今年累计积分
        CurrYearPointsMax: "", // 今年累计积分
        FirstVipDateStart: "", // 升级为VIC的时间
        FirstVipDateEnd: "", // 升级为VIC的时间
        lvlExpireDateStart: "",
        lvlExpireDateEnd: "",
        UpdateLvlOrgIds: [], // 升级为VIC的机构
        UpdateLvlRegionIds: [], // 升级为VIC的区域
        PrevYearSaleTimesMin: "", // 去年消费次数
        PrevYearSaleTimesMax: "", // 去年消费次数
        CurrYearSaleTimesMin: "", // 今年消费次数
        CurrYearSaleTimesMax: "", // 今年消费次数
        AvgSheetAmtMin: "", // 平均客单价
        AvgSheetAmtMax: "", // 平均客单价
        AvgDiscountMin: "", // 平均折扣
        AvgDiscountMax: "", // 平均折扣
      };
      this.skuship= []; //存储列表
      this.lingsList= [];
      this.tableData = [];
      // 选择门店数据
      this.shopId= [];
      this.StoredataArray= [];
      this.StoreSelectLength= 0;
      this.ServiceOrgName= ""; //维护店
      this.FirstVipOrgName= ""; //升级为VIC的机构
      this.ServiceTagName="";
      this.dateValue1="";
      this.protectionDate="";
      this.viewCustomers();
    },
    //区域渲染数据
    async regioNalinformation() {
      const res = await regionalQuery({ deptLevel: "0" });
      this.regionIDList = res.data;
    },
    //门店渲染数据
    async orgInformation() {
      const res = await regionalQuery({ deptLevel: "1" });
      this.orgIDList = res.data;
    },
    //获取下载列表数据
    getDownladList() {
      reportFormList({
        groupName: "企业微信客户转移导入",
      }).then((response) => {
        console.log(response);
        this.downloadData = response.data;
      });
    },
    //获取下载列表数据
    getDownladExportList() {
      reportFormList({
        groupName: "企业微信客户转移导出",
      }).then((response) => {
        console.log(response);
        this.downloadData = response.data;
      });
    },
    /*下载导出结果*/
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = process.env.VUE_APP_BASE_API + src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },

    // 列表数据
    async viewCustomers() {

      const { data: res } = await queryFollowUserRequestLisApi(require("qs").stringify(this.processingParams()));
      if (this.queryInfo.pageNo == 1) this.tableData = [];

      this.tableData = this.tableData.concat(res.list);
      this.queryInfo.pages = res.pages;
      this.loading = false;
    },
    //会员管理初始化tabar表格滚动加载
    load() {
      this.loading = true;
      setTimeout(() => {
        this.queryInfo.pageNo += 1;
        this.viewCustomers();
      }, 1000);
    },
    // 查询
    SearchBtn() {
      this.queryInfo.pageNo = 1;
      this.viewCustomers();
    },

    //导入Excel
    ImprotExcel() {
      this.WeComCustmerImport = true;
    },
    //下载模板
    templatebtn() {
      const ele = document.createElement("a");
      ele.style.display = "none";
      // 设置href属性为文件路径，download属性可以设置文件名称
      ele.href =
          process.env.VUE_APP_BASE_API + "/api/templates/客户转移模板.xlsx";
      ele.download = "";
      // 将a标签添加到页面并模拟点击
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      // 移除a标签
      ele.remove();
    },
    onFileChange(file) {
      this.filename = file.name;
      this.file = file.raw;
    },
    //选择文件上传
    Selectupload() {
      let formData = new FormData(); //声明一个FormDate对象
      formData.append("file", this.file); //把文件信息放入对象中
      formData.append("msg", this.importmsg); //把文件信息放入对象中

      if(formData.get("file")==""||formData.get("file")==null||formData.get("file")=="null"){
        return this.$message.warning("请选择文件");
      }

      if(formData.get("msg")==""||formData.get("msg")==null){
        return this.$message.warning("请填写文案内容");
      }
      //调用后台导入的接口
      importWebComExlsx(formData)
          .then((res) => {
            console.log(res);
            if (res.code == 0) {
              // 导入表格之后可以获取导入的数据渲染到页面，此处的方法是获取导入的数据
            } else {
              // loading.close();
              this.$message.success("导入成功请在下载列表查看");
              // this.defaultisderived = true;
              // this.successUrl = res.data;
              this.WeComCustmerImport = false;
            }
          })
          .catch((err) => {
            console.log(err);
            // loading.close();
            this.$message({
              type: "error",
              message: "导入失败",
            });
          });
    },

    // 导出
    exportCustomer() {
      followUserExportApi(require("qs").stringify(this.processingParams())).then((res) => {
        if (res.success !== true) {
          this.$message.error("导出失败!!!");
        } else {
          this.exportShow = false;
          this.$message.success("导出成功请在下载列表查看!");
        }
        this.followUserIDValue=[];
      });

    },

    // 选择标签
    ComButtomTag() {
      //获取已选择的门店数据
      let listOfSomeTagsl = [];
      let listOfSomeTagslStr = "";
      for (let index = 0; index < this.TagSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.TagdataArray[index].chlidren.length + 1) {
          listOfSomeTagsl.push(...this.TagdataArray[index].chlidren);
        } else {
          listOfSomeTagsl.push(...item);
        }
      }
      listOfSomeTagsl.forEach((item) => {
        listOfSomeTagslStr += `${item.groupName}\n`;
      });
      let tagId = []; //选中标签数据
      for (let i = 0; i < listOfSomeTagsl.length; i++) {
        tagId.push(listOfSomeTagsl[i].tagGroupID);
      }

      if (this.flag == 1) {
        this.ServiceTagName = listOfSomeTagslStr;
        this.queryInfo.tagIDArr = tagId;
      }
      this.outletVisible = false;
    },

    // 获取标签
    QueryTagList() {
      queryTagListApi({ state: 1 }).then((res) => {
        let arr1 = [],
            arr2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.TagdataArray.push(item);
          });
          this.TagdataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.ShopID = item.tagGroupID;
            });
            this.TagSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.TagSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //点击选中员工
    pitchup(e) {
      this.changeSelectStyle = e.target.dataset.name;
      if (this.rSelect.indexOf(e.target.dataset.name) !== -1) {
        this.rSelect.splice(this.rSelect.indexOf(e.target.dataset.name), 1);
      } else {
        this.rSelect.push(e.target.dataset.name);
      }
      this.queryInfo.skus = this.rSelect.join(",");
    },
    //员工新增功能
    addbtn(){
      this.experimental = true;
      this.skuship = [];
      this.PagesStaff.empCode="";
      this.PagesStaff.empName="";
      this.Searchbtn();
    },
    //员工删除功能
    deletebtn() {
      let arr = [];
      for (let i = 0; i < this.queryInfo.emplist.length; i++) {
        let item = this.queryInfo.emplist[i];
        arr.push(item.empName);
      }
      for (let i = 0; i < this.rSelect.length; i++) {
        let item = this.rSelect[i];
        if (arr.indexOf(item) !== -1) {
          this.queryInfo.emplist.splice(arr.indexOf(item), 1);
        }
      }
      this.$forceUpdate();
    },
    ReturnempKindText(index) {
      let text = "";
      switch (index) {
        case 1:
          text = "门店员工";
          break;
        case 2:
          text = "区域员工";
          break;
        case 3:
          text = "公司员工";
          break;
      }
      return text;
    },
    //员工表格滚动加载
    PageTouchTheBottomStaff() {
      this.PageTableLoadingStaff = true;
      setTimeout(() => {
        this.PagesStaff.pageNo += 1;
        this.Searchbtn();
      }, 200);
    },
    searchhy() {
      this.PagesStaff.pagesTotal = 0;
      this.PagesStaff.pageNo = 1;
      this.lingsList = [];
      this.skuship = [];
      this.Searchbtn();
    },
    async Searchbtn() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        pageSize: this.PagesStaff.pageSize,
        pageNo: this.PagesStaff.pageNo,
        empCode: this.PagesStaff.empCode,
        empKind: null,
        shopNameOrCode: null,
        empName: this.PagesStaff.empName,
      });
      selectEmpList(data).then((res) => {
        if (res.success) {
          res.data.list.forEach((item) => {
            item.empKindText = this.ReturnempKindText(parseInt(item.empKind));
          });
          this.skuship =this.skuship.concat(res.data.list);
          this.PagesStaff.pagesTotal = res.pages;
          this.PagesStaff.total = res.data.total;
          this.PageTableLoadingStaff = false;
        } else {
          this.$message.error(res.message);
        }

      });

    },
    handleSelectionChangeStaff(val) {
      this.lingsList = val;
      return val;
    },
    //添加人--选择添加人保存
    affirm() {
      const allItems= this.queryInfo.emplist.concat(this.lingsList);
      this.queryInfo.emplist=allItems.reduce((acc, item) => {
        if (!acc.some(i => i.empID === item.empID)) { // 基于empID属性检查是否已存在相同项
          acc.push(item);
        }
        return acc;
      }, []);
      this.$forceUpdate();
      this.$message({
        message: "添加成功",
        type: "success",
      });

      this.experimental = false;
    },

    //参数处理
    processingParams() {
      const weChatUserArray = [];
      console.log(this.queryInfo.shopIds);
      if(this.queryInfo.emplist != undefined && this.queryInfo.emplist!=[] &&  this.queryInfo.emplist.length>0){
        this.queryInfo.emplist.forEach(item => {
          weChatUserArray.push(item.weChatUserID);
        });
      }
      if (this.dateValue1 && this.dateValue1.length > 0) {
        this.queryInfo.RegistDateStart = this.renderTime(
            this.dateValue1[0]
        ).substring(0, 10);
        this.queryInfo.RegistDateEnd = this.renderTime(
            this.dateValue1[1]
        ).substring(0, 10);
      } else {
        this.queryInfo.RegistDateStart = undefined;
        this.queryInfo.RegistDateEnd = undefined;
      }
      if (this.dateValue3 && this.dateValue3.length > 0) {
        this.queryInfo.LastSaleDateStart = this.renderTime(
            this.dateValue3[0]
        ).substring(0, 10);
        this.queryInfo.LastSaleDateEnd = this.renderTime(
            this.dateValue3[1]
        ).substring(0, 10);
      } else {
        this.queryInfo.LastSaleDateStart = undefined;
        this.queryInfo.LastSaleDateEnd = undefined;
      }
      if (this.dateValue4 && this.dateValue4.length > 0) {
        this.queryInfo.FirstVipDateStart = this.renderTime(
            this.dateValue4[0]
        ).substring(0, 10);
        this.queryInfo.FirstVipDateEnd = this.renderTime(
            this.dateValue4[1]
        ).substring(0, 10);
      } else {
        this.queryInfo.FirstVipDateStart = undefined;
        this.queryInfo.FirstVipDateEnd = undefined;
      }
      // 保级日期
      if (this.protectionDate && this.protectionDate.length > 0) {
        this.queryInfo.lvlExpireDateStart = this.renderTime(
            this.protectionDate[0]
        ).substring(0, 10);
        this.queryInfo.lvlExpireDateEnd = this.renderTime(
            this.protectionDate[1]
        ).substring(0, 10);
      } else {
        this.queryInfo.lvlExpireDateStart = "";
        this.queryInfo.lvlExpireDateEnd = "";
      }
      let data = {
        wecharUserIDArr:weChatUserArray.toString(),
        pageNo: this.queryInfo.pageNo,
        pageSize: this.queryInfo.pageSize,
        regionName: this.queryInfo.regionName,
        remark: this.queryInfo.remark,
        custName: this.queryInfo.custName,
        deptName: this.queryInfo.deptName,
        wecharUserID: this.queryInfo.wecharUserID,
        userName: this.queryInfo.userName,
        regionIdArr: this.queryInfo.regionIdArr.toString(),
        deptIdArr: this.queryInfo.deptIdArr.toString(),
        tagIDArr: this.queryInfo.tagIDArr.toString(),

        search:
            this.queryInfo.cusInfo == "" ? undefined : this.queryInfo.cusInfo,
        serviceShopIds:
        this.queryInfo.shopIds==undefined || this.queryInfo.shopIds.length == 0
                ? undefined
                : this.queryInfo.shopIds,
        multipleQty: this.queryInfo.multipleQty == true ? 1 : "",
        registDateStart: this.queryInfo.RegistDateStart,
        registDateEnd: this.queryInfo.RegistDateEnd,
        serviceRegionIds:
            this.queryInfo.regionIds==undefined ||  this.queryInfo.regionIds.length == 0
                ? undefined
                : this.queryInfo.regionIds,
        levelIDs:
            this.queryInfo.LevelID==undefined ||   this.queryInfo.LevelID.length == 0
                ? undefined
                : this.queryInfo.LevelID,
        cardNo: this.queryInfo.cardNo == "" ? undefined : this.queryInfo.cardNo,
        name:
            this.queryInfo.userName == "" ? undefined : this.queryInfo.userName,
        mobile: this.queryInfo.Mobile == "" ? undefined : this.queryInfo.Mobile,
        provinceName:
            this.queryInfo.provinceName == ""
                ? undefined
                : this.queryInfo.provinceName,
        serviceEmpName:
            this.queryInfo.ServiceEmpName == ""
                ? undefined
                : this.queryInfo.ServiceEmpName,
        cityName:
            this.queryInfo.cityName == "" ? undefined : this.queryInfo.cityName,
        birthMonthStart: this.queryInfo.birthMonthStart,
        birthMonthEnd: this.queryInfo.birthMonthEnd,
        birthDateStart: this.queryInfo.birthDateStart,
        birthDateEnd: this.queryInfo.birthDateEnd,
        ageMin: this.queryInfo.ageMin,
        ageMax: this.queryInfo.ageMax,
        lastSaleDateStart: this.queryInfo.LastSaleDateStart,
        lastSaleDateEnd: this.queryInfo.LastSaleDateEnd,
        tagIds:
            this.queryInfo.tagIds.length == 0 ? undefined : this.queryInfo.tagIds,
        isMillVIP:
            this.queryInfo.isMillVIP == "" ? undefined : this.queryInfo.isMillVIP,
        isServiceEmp:
            this.queryInfo.isServiceEmp == ""
                ? undefined
                : this.queryInfo.isServiceEmp,
        currYearAmountMin:
            this.queryInfo.CurrYearAmountMin == ""
                ? undefined
                : this.queryInfo.CurrYearAmountMin,
        currYearAmountMax:
            this.queryInfo.CurrYearAmountMax == ""
                ? undefined
                : this.queryInfo.CurrYearAmountMax,
        prevYearAmountMin:
            this.queryInfo.PrevYearAmountMin == ""
                ? undefined
                : this.queryInfo.PrevYearAmountMin,
        prevYearAmountMax:
            this.queryInfo.PrevYearAmountMax == ""
                ? undefined
                : this.queryInfo.PrevYearAmountMax,
        lastYearAmountMin:
            this.queryInfo.LastYearAmountMin == ""
                ? undefined
                : this.queryInfo.LastYearAmountMin,
        lastYearAmountMax:
            this.queryInfo.LastYearAmountMax == ""
                ? undefined
                : this.queryInfo.LastYearAmountMax,
        sheetTopAmt1Min:
            this.queryInfo.SheetTopAmt1Min == ""
                ? undefined
                : this.queryInfo.SheetTopAmt1Min,
        sheetTopAmt1Max:
            this.queryInfo.SheetTopAmt1Max == ""
                ? undefined
                : this.queryInfo.SheetTopAmt1Max,
        sheetTopAmt2Min:
            this.queryInfo.SheetTopAmt2Min == ""
                ? undefined
                : this.queryInfo.SheetTopAmt2Min,
        sheetTopAmt2Max:
            this.queryInfo.SheetTopAmt2Max == ""
                ? undefined
                : this.queryInfo.SheetTopAmt2Max,
        sheetTopAmt3Min:
            this.queryInfo.SheetTopAmt3Min == ""
                ? undefined
                : this.queryInfo.SheetTopAmt3Min,
        sheetTopAmt3Max:
            this.queryInfo.SheetTopAmt3Max == ""
                ? undefined
                : this.queryInfo.SheetTopAmt3Max,
        monetaryMin:
            this.queryInfo.MonetaryMin == ""
                ? undefined
                : this.queryInfo.MonetaryMin,
        monetaryMax:
            this.queryInfo.MonetaryMax == ""
                ? undefined
                : this.queryInfo.MonetaryMax,
        frequencyMin:
            this.queryInfo.FrequencyMin == ""
                ? undefined
                : this.queryInfo.FrequencyMin,
        frequencyMax:
            this.queryInfo.FrequencyMax == ""
                ? undefined
                : this.queryInfo.FrequencyMax,
        tMaxMoneyMin:
            this.queryInfo.TMaxMoneyMin == ""
                ? undefined
                : this.queryInfo.TMaxMoneyMin,
        tMaxMoneyMax:
            this.queryInfo.TMaxMoneyMax == ""
                ? undefined
                : this.queryInfo.TMaxMoneyMax,
        saleTagID:
            this.queryInfo.saleTagID == "" ? undefined : this.queryInfo.saleTagID, //RMF标签
        hasRelegation:
            this.queryInfo.HasRelegation == ""
                ? undefined
                : this.queryInfo.HasRelegation,
        canDegradeLvl:
            this.queryInfo.CanDegradeLvl == ""
                ? undefined
                : this.queryInfo.CanDegradeLvl,
        currAvailPointMin:
            this.queryInfo.CurrAvailPointMin == ""
                ? undefined
                : this.queryInfo.CurrAvailPointMin,
        currAvailPointMax:
            this.queryInfo.CurrAvailPointMax == ""
                ? undefined
                : this.queryInfo.CurrAvailPointMax,
        preYearPointsMin:
            this.queryInfo.PreYearPointsMin == ""
                ? undefined
                : this.queryInfo.PreYearPointsMin,
        preYearPointsMax:
            this.queryInfo.PreYearPointsMax == ""
                ? undefined
                : this.queryInfo.PreYearPointsMax,
        currYearPointsMin:
            this.queryInfo.CurrYearPointsMin == ""
                ? undefined
                : this.queryInfo.CurrYearPointsMin,
        currYearPointsMax:
            this.queryInfo.CurrYearPointsMax == ""
                ? undefined
                : this.queryInfo.CurrYearPointsMax,
        firstVipDateStart: this.queryInfo.FirstVipDateStart,
        firstVipDateEnd: this.queryInfo.FirstVipDateEnd,
        lvlExpireDateStart: this.queryInfo.lvlExpireDateStart,
        lvlExpireDateEnd: this.queryInfo.lvlExpireDateEnd,
        updateLvlOrgIds:
            this.queryInfo.UpdateLvlOrgIds.length == 0
                ? undefined
                : this.queryInfo.UpdateLvlOrgIds,
        updateLvlRegionIds:
            this.queryInfo.UpdateLvlRegionIds.length == 0
                ? undefined
                : this.queryInfo.UpdateLvlRegionIds,
        prevYearSaleTimesMin:
            this.queryInfo.PrevYearSaleTimesMin == ""
                ? undefined
                : this.queryInfo.PrevYearSaleTimesMin,
        prevYearSaleTimesMax:
            this.queryInfo.PrevYearSaleTimesMax == ""
                ? undefined
                : this.queryInfo.PrevYearSaleTimesMax,
        currYearSaleTimesMin:
            this.queryInfo.CurrYearSaleTimesMin == ""
                ? undefined
                : this.queryInfo.CurrYearSaleTimesMin,
        currYearSaleTimesMax:
            this.queryInfo.CurrYearSaleTimesMax == ""
                ? undefined
                : this.queryInfo.CurrYearSaleTimesMax,
        avgSheetAmtMin:
            this.queryInfo.AvgSheetAmtMin == ""
                ? undefined
                : this.queryInfo.AvgSheetAmtMin,
        avgSheetAmtMax:
            this.queryInfo.AvgSheetAmtMax == ""
                ? undefined
                : this.queryInfo.AvgSheetAmtMax,
        avgDiscountMin:
            this.queryInfo.AvgDiscountMin == ""
                ? undefined
                : this.queryInfo.AvgDiscountMin,
        avgDiscountMax:
            this.queryInfo.AvgDiscountMax == ""
                ? undefined
                : this.queryInfo.AvgDiscountMax,
      };
      console.log(data.serviceShopIds)
      return data;
    },
    ShopqueryRegionList() {
      RegionApi().then((res) => {
        let arr1 = [],
            arr2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.shopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    ComButtomStore() {
      // 获取已选择的门店数据
      let listOfSomeStoresl = [];
      let listOfSomeStoreslStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          listOfSomeStoresl.push(...this.StoredataArray[index].chlidren);
        } else {
          listOfSomeStoresl.push(...item);
        }
      }
      listOfSomeStoresl.forEach((item) => {
        listOfSomeStoreslStr += `${item.lable}\n`;
      });
      let shopId = []; //选中门店数据
      for (let i = 0; i < listOfSomeStoresl.length; i++) {
        shopId.push(listOfSomeStoresl[i].id);
      }
      if (this.flag == 3) {
        this.ServiceOrgName = listOfSomeStoreslStr;
        this.queryInfo.shopIds = shopId;
      } else if (this.flag == 4) {
        this.FirstVipOrgName = listOfSomeStoreslStr;
        this.queryInfo.UpdateLvlOrgIds = shopId;
      }
      this.outOrgletVisible = false;

    },

    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
            .toISOString()
            .replace(/T/g, " ")
            .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },

  },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__footer {
  height: 60px;
  background-color: #f2f2f2;
}
#wecomcustomer {
  // height: 1200px;
  height: 100%;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
.centercard {
  margin-top: 10px;
}
.searchform {
  margin-top: 10px;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

.el-table .warning-row {
  background: #fcfbf2;
}

.el-table .success-row {
  background: #ffffff;
}
::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-dialog__header {
    background-color: #f3f1dd;
  }
  // 转店申请弹窗样式
  .apply {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 16px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 0 20px 0;
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .import {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 10px 30px 20px 30px;
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .resui {
    display: flex;
    flex-direction: column;
  }
  .resui span {
    line-height: 30px;
    font-size: 18px;
  }

  // 导出弹框样式

  .exporttc {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .dialogTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 50px;
  }
  .dialogTitle > span {
    font-size: 16px;
    font-weight: 700;
    color: #6c6937;
  }
  .boxstr {
    width: 100%;
    height: 180px;
    overflow-y: auto;
    border: 1px solid #666;
    li {
      list-style: none;
      line-height: 25px;
      padding-left: 8px;
    }

    .changeStyle {
      color: #fff;
      background-color: #409eff;
    }
    .setime {
      display: flex;
      justify-content: space-around;
    }
  }
  .boxsize {
    background-color: #f2f2f2;
    color: #4d4d4d;
    margin-left: 46%;
    position: absolute;
    top: 60px;
    left: 13px;
  }
  .boxsizeuu {
    background-color: #f2f2f2;
    color: #4d4d4d;
    position: relative;
    top: 120px;
    left: 337px;
  }
}
</style>
